import qs from 'querystring';
import { format } from 'date-fns';
import { isDate } from 'lodash-es';

export const goToStationWeb = () => {
    window.location.href = `${process.env.REACT_APP_STATION_WEB_URI}/browse/reports` || window.location.origin;
}

/**
 * Creates a link to the TruSTAR login page based on your current env, with a base64 url of where to return
 * after success auth (e.g. the page that sent you there)
 */
export const generateAuthUrl = (
    onSuccessReturnToUrl: string = window.location.href
) => {
    const queryParams = qs.stringify({
        cfa: btoa(onSuccessReturnToUrl), // cfa - Coming From App
    });
    
    return `${process.env.REACT_APP_TS_LOGIN_PAGE}?${queryParams}`;
};

/**
 * Similar to the above only for the logout flow, sends through the logout flow and brings you back to the same login that you would get
 * from the funciton above
 */
export const generateLogoutAuthUrl = (
    onSuccessReturnToUrl: string = window.location.href
) => {
    const queryParams = qs.stringify({
        cfa: btoa(onSuccessReturnToUrl), // cfa - Coming From App
    });
    // Swap LOGOUT for LOGIN due to invalidation
    return `${process.env.REACT_APP_TS_LOGOUT_PAGE}?${queryParams}`;
};

export const formatDate = (value: any, formatString: string = 'M/d/yyyy') => {
    try {
        const dateToFormat = isDate(value) ? value : new Date(value);

        return format(dateToFormat, formatString);
    } catch (error) {
        return '';
    }
};

/**
 * Initialize the prefixing of all your redux actions with this.
 * It applies the current application name taken frm package.json and prefixes everything with it
 * 
 * Usage -      
 * const prefix = actionPrefixer('SomeModule);   
 * const helloAction = prefix('HELLO_ACTION');    
 *  ---> helloAction = 'APPNAME/SomeModule/HELLO_ACTION'   
 * 
 * @param moduleName - the name of the redux module
 * @returns prefix function for you name action types with
 */

 const appName: string = PACKAGE_JSON_PROP.name;

export const actionPrefixer = (moduleName: string) => {
    const prefixWithAppAndModuleName = (actionType: string) => `${appName}/${moduleName}/${actionType}`;
    return prefixWithAppAndModuleName;
}

/**
 * Checks if provided color is light.
 * @param color - Hex color value.
 * @returns {boolean}
 */
export const isColorLight = (hexColor: string) => {
  const hex = hexColor.replace('#', '');
  const red = parseInt(hex.substr(0, 2), 16);
  const green = parseInt(hex.substr(2, 2), 16);
  const blue = parseInt(hex.substr(4, 2), 16);
  const brightness = ((red * 299) + (green * 587) + (blue * 114)) / 1000;

  return brightness > 155;
}
